import { configureStore } from "@reduxjs/toolkit";
import { homeSlice, authSlice, productSlice, branchSlice, ordersSlice, pendingLoanSlice, forgotPasswordSlice, historySlice, settingsSlice, livePricingSlice, clientSlice, clientInfoChangeRequestSlice, newsSlice, marketUpdateSlice, pendingWithDrawalSlice, bankSlice, supportTeamSlice, liveTransactionsSlice, countrySlice, offerSlice, adminSlice, reportsSlice, complianceSlice, accountMappingSlice, physicalMappingSlice, fixingMappingSlice, bankAccountMappingSlice, goldProductMappingSlice, temporaryCreditSlice, websiteOrdersSlice, transactionStatsSlice, salesAgentSlice, commissionSlice, referralClientsSlice, agentAuthSlice, agentDashboardSlice, agentTransactionsSlice, setupResponseInterceptors, setupAgentResponseInterceptors, agentClientsSlice, agentWithDrawalsSlice, agentEsouqOrdersSlice, chatSlice, kycSlice, onlineUsersSlice } from "./index";

const store = configureStore({
  reducer: {
    home: homeSlice,
    auth: authSlice,
    forgotPassword: forgotPasswordSlice,
    products: productSlice,
    branches: branchSlice,
    orders: ordersSlice,
    loanRequests: pendingLoanSlice,
    history: historySlice,
    settings: settingsSlice,
    livePricing: livePricingSlice,
    clients: clientSlice,
    clientInfoChangeRequest: clientInfoChangeRequestSlice,
    news: newsSlice,
    marketUpdates: marketUpdateSlice,
    withDrawalRequests: pendingWithDrawalSlice,
    banks: bankSlice,
    supportTeams: supportTeamSlice,
    liveTransactions: liveTransactionsSlice,
    country: countrySlice,
    offer: offerSlice,
    admin: adminSlice,
    reports: reportsSlice,
    compliance: complianceSlice,
    accountMappings: accountMappingSlice,
    physicalMappings: physicalMappingSlice,
    fixingMappings: fixingMappingSlice,
    bankAccountMapping: bankAccountMappingSlice,
    goldProducts: goldProductMappingSlice,
    temporaryCredits: temporaryCreditSlice,
    websiteOrders: websiteOrdersSlice,
    transactionStats: transactionStatsSlice,
    salesAgents: salesAgentSlice,
    commissions: commissionSlice,
    referralClients: referralClientsSlice,
    agentAuth: agentAuthSlice,
    agentDashboard: agentDashboardSlice,
    agentTransactionsStats: agentTransactionsSlice,
    agentClients: agentClientsSlice,
    agentWithDrawals: agentWithDrawalsSlice,
    agentEsouqOrders: agentEsouqOrdersSlice,
    chat: chatSlice,
    kyc: kycSlice,
    onlineUsers: onlineUsersSlice,
  }
});

setupResponseInterceptors(store);
setupAgentResponseInterceptors(store);

// Derived here, in the file that creates the store, rather than in types.ts.
// types.ts is imported by the slices (for their state shapes), the slices are
// imported here, so having types.ts import the store back formed an import
// cycle that only held together because TS happened to elide the type-only
// import.
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
